var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"vx-col flex items-center justify-center flex-col  mx-auto text-center"},[_c('img',{staticClass:"mx-auto max-w-full",attrs:{"src":_vm.homepageImage,"alt":"home-page-image"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }